export default "__VITE_ASSET__D7ly$y2D__"